'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getEnvVariables = exports.getEnvVariables = function getEnvVariables() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (force || (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process.env) return process.env;
  console.error(['\n', new Array(100).join('*'), '* process.env not found. default to e3', new Array(100).join('*'), '\n'].join('\n'));
  return {
    NODE_ENV: 'e3'
  };
};

var e0Server = exports.e0Server = function e0Server(env) {
  if (!env) return false;
  var environments = [env.EPAAS_ENV, env.ENV, env.NODE_ENV];
  return env.TERM_PROGRAM === 'Apple_Terminal' || environments.indexOf('local_development') !== -1 || environments.indexOf('e0') !== -1;
};

var e1Server = exports.e1Server = function e1Server(env) {
  if (!env) return false;
  var environments = [env.EPAAS_ENV, env.ENV, env.NODE_ENV];
  return environments.indexOf('e1') !== -1 || environments.indexOf('dev') !== -1;
};

var e2Server = exports.e2Server = function e2Server(env) {
  if (!env) return false;
  var environments = [env.EPAAS_ENV, env.ENV, env.NODE_ENV];
  return environments.indexOf('e2') !== -1 || environments.indexOf('qa') !== -1;
};

var e3Server = exports.e3Server = function e3Server(env) {
  if (!env) return false;
  var environments = [env.EPAAS_ENV, env.ENV, env.NODE_ENV];
  return environments.indexOf('e3') !== -1 || environments.indexOf('production') !== -1;
};

var defaultServer = exports.defaultServer = function defaultServer(env) {
  if (e3Server(env)) return true;
  console.error(['\n', new Array(100).join('*'), '* no default server environment found. server will default to e3', new Array(100).join('*'), '\n'].join('\n'));
  return true;
};

var getEnv = exports.getEnv = function getEnv(env) {
  var environments = env || getEnvVariables();
  var fns = [[e3Server, 'e3'], [e2Server, 'e2'], [e1Server, 'e1'], [e0Server, 'e0'], [defaultServer, 'e3']];

  for (var i = 0, len = fns.length; i < len; i++) {
    if (fns[i][0](environments)) {
      return fns[i][1];
    }
  }
};

var setEnv = exports.setEnv = function setEnv(process, key, value) {
  if (!process) return false;
  //NOTE: handle webpack stringify version of process.env
  process.env[key] = value;
  return true;
};